import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Label/LabelUsage.mdx";

import Examples from "../../Docs/Components/Label/LabelExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Label"
            description="The label component is being reviewed and may change. The label component is used to add tags and other metadata to objects."
            apiSources={["azure-devops-ui/Components/Label/Label.Props.d.ts"]}
            examples={Examples}
            status={{"design":"underReview","code":"underReview","docs":"underReview"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;